import styled from 'styled-components';

export const ContactUsWrapper = styled.div`
    .content {
        display: inline-block;
        padding: 1em 5em;
        min-height: 80vh
    }
`;
